import { useState } from 'react'
import printConfig from '../../../print-config.json'
import config from '../../../config.json'
import requestStatusConstants from "../../../constants/requestStatus";
import { Link } from 'react-router-dom';
import actionTypes from '../../../actions/actionTypes';
import { PreviewPrintButtons } from './FlyerButtons';
import Translation from '../../Translation/cont/Translation';
import WrapperPageSpinner from '../../WrapperPage/present/WrapperPageSpinner';
import ListToogleAllButtons from '../../DragAndDropList/presents/ListToogleAllButtons';
import ListDrag from '../../DragAndDropList/presents/ListDrag';
import dndItemTypes from '../../../constants/dndItemTypes';
import { BOTTOMITEMS, CHOOSENMOVIES, CUSTOMITEMS, MOVIE } from '../../../constants/itemTypes';
import FlyerDragSwitch from './FlyerDragSwitch';
import NewspaperDropzoneContainer from '../cont/NewspaperDropzoneContainer';

const filterConfig = [
    {
        id: 'genres',
        transId: 'movie_edit_movie_genres'
    },
    {
        id: 'technical',
        transId: 'section_filter_select_film_series_title_display'
    },
    {
        id: 'fsk',
        transId: 'movie_attributes_fsk'
    },
    {
        id: 'period',
        transId: 'section_filter_select_period_display_title'
    },
]

const PrintNewspaper = ({
    cinemaId,
    printID,
    printType,
    landscape,
    requestStatus,
    printPk,
    requestError,
    requestOverlay,
    activeWeek,
    hasChanges,
    features,
    newspaperData,
    basicUrl,
    printNewspaperRequest, 
    printUpdateRequest,
    dragListConfig,
    displayDropzones,
    closePagePath,
    relevantMoviesData,
    onPrintNewspaperPdfResetState,

    reorderNewspaperItems,
    deleteNewspaperItem,
    addNewspaperItem
}) => {
    if(!features) {
        return ''
    }

    const { requestType } = requestOverlay
    const { REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatusConstants
    const isRequest =  actionTypes.PRINT_DATA_NEWSPAPER_PDF_REQUEST === requestType

    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)
    const [isAllOpen, setAllOpen] = useState(true)
    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''

    let buttonTextTransId

    if(requestStatus === REQUEST_PENDING ) {
        buttonTextTransId = "print_PDF_is_generated"
    } else if(requestStatus === REQUEST_ERROR) {
        buttonTextTransId =  "print_PDF_error"
    } else {
        buttonTextTransId = "print_generate_PDF"
    }

    return (
        <WrapperPageSpinner
            pageTitleTransId={printConfig.routes[printType].transIdname}
            closePagePath={closePagePath} 

            pending={isRequest && REQUEST_PENDING === requestStatus}
            error={isRequest && REQUEST_ERROR === requestStatus}
            success={isRequest && REQUEST_SUCCESS === requestStatus}
        
            pendingTextTransId='print_PDF_is_generated'
            errorTextTransId='print_error_occurred_while_generating'
            successTextTransId='print_PDF_successfully_generated'
        
            errorMsg={requestError ? requestError : ''}
            successMsg='Es befindet sich in dem Downloadordner oder ist über die Downloadhistorie des Browsers zu finden. Je nach Downloadeinstellung kann sich der Speicherort unterscheiden.'
        
            onClickSuccesButton={onPrintNewspaperPdfResetState}
            onClickErrorButton={onPrintNewspaperPdfResetState}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                {features.has_newspaper ? (
                    <div className="selections-item">
                        <div className="selections-item-content accordion-item">
                            <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                                <Link className={"button-wrapper button gap-20"} to={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${landscapeBoolean}/${activeWeek}/all/edit/newspaper/${printPk}`}>
                                    <div className={"button-text"}><Translation id="button_edit_settings"/></div>
                                </Link>
                                <ListToogleAllButtons
                                    setAllOpen={setAllOpen}
                                />
                                <div className="program-list film-content">
                                    {dragListConfig.map(({
                                        titleTransId,
                                        buttonTextTransId,
                                        type,
                                        listType,
                                        itemsType,
                                        hasAddNewItem,
                                        hasRemoveItem,
                                    }, index) => {
                                        let items = {}
                                        let itemsOrder = []
                                        let selectedItems = []
                                        
                                        if('currentMovies' === itemsType) {
                                            items = relevantMoviesData.items
                                            itemsOrder = relevantMoviesData.current
                                            selectedItems = relevantMoviesData.selected
                                        } else if('futureMovies' === itemsType) {
                                            items = relevantMoviesData.items
                                            itemsOrder = relevantMoviesData.future
                                            selectedItems = relevantMoviesData.selected
                                        } else if ('customItems' === itemsType) {
                                            items = newspaperData.customItems.items
                                            itemsOrder = _.keys(newspaperData.customItems.items)
                                            selectedItems = []
                                        }

                                        return (
                                            <div key={index}>
                                                {/* {'currentMovies' === itemsType && (
                                                    <ListToggleDisplayWrapper
                                                        className=''
                                                        titleTransId='movie_filter_actions_title'
                                                        defaultIsOpen={isAllOpen}
                                                        setAllOpen={setAllOpen}
                                                    >
                                                        <MoviesFilterActionsContainer
                                                            filterConfig={filterConfig}
                                                            // listId={}
                                                            dropStructureData={false}
                                                            relevantAttributes={relevantMoviesData.attributes}
                                                            relevantMovies={relevantMoviesData.order}
                                                            currentMovies={relevantMoviesData.current}
                                                            futureMovies={relevantMoviesData.future}
                                                            selectedItems={relevantMoviesData.order}
                                                            addItem={(listId, itemId, targetId) => addNewspaperItem(itemId)}
                                                            deleteItem={(listId, itemId, targetId) => deleteNewspaperItem(itemId)}
                                                        />
                                                    </ListToggleDisplayWrapper>
                                                )} */}

                                                <ListDrag
                                                    titleTransId={titleTransId}
                                                    buttonTextTransId={buttonTextTransId}
                                                    listId={'newspaper_' + listType}
                                                    type={type}
                                                    dndType={dndItemTypes.NEWSPAPER_ITEM_ADD}

                                                    defaultIsOpen={isAllOpen}
                                                    setAllOpen={setAllOpen}

                                                    order={itemsOrder}
                                                    items={items}
                                                    className=''
                                                    ChildSwitchItem={FlyerDragSwitch}
                                                    selected={selectedItems}
                                                    params={false}
                                                    basicUrl={basicUrl}
                                                    canEdit={true}
                                                    canDelete={true}
                                                    pathnameAdd={hasAddNewItem ? `${basicUrl}/${type}/addItem/form` : false}
                                                    deleteItem={hasRemoveItem ? null : null}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                                 <ul className="periode-list">
                                    <NewspaperDropzoneContainer
                                        labelTransId={'program_list_movie_selection'}
                                        newspaperData={newspaperData}
                                        dndType={dndItemTypes.NEWSPAPER_ITEM_ADD}
                                        displayDropzones={displayDropzones}
                                        cinemaId={cinemaId}
                                        basicUrl={basicUrl}
                                        dataType={CHOOSENMOVIES}
                                        canDropTypes={[MOVIE]}
                                        deleteNewspaperItem={deleteNewspaperItem}
                                        relevantMoviesData={relevantMoviesData}
                                        addNewspaperItem={addNewspaperItem}
                                    />
                                    <NewspaperDropzoneContainer
                                        labelTransId={'print_newspaper_bottom_section'}
                                        newspaperData={newspaperData}
                                        dndType={dndItemTypes.NEWSPAPER_ITEM_ADD}
                                        displayDropzones={displayDropzones}
                                        cinemaId={cinemaId}
                                        basicUrl={basicUrl}
                                        dataType={BOTTOMITEMS}
                                        canDropTypes={[CUSTOMITEMS]}
                                        deleteNewspaperItem={deleteNewspaperItem}
                                        addNewspaperItem={addNewspaperItem}
                                    />
                                </ul>
                            </div>
                        </div>

                        <PreviewPrintButtons 
                            hasChanges={hasChanges}
                            buttonTextTransId={buttonTextTransId}
                            cinemaId={cinemaId}
                            printPk={printPk}
                            printType={printType}
                            currentPrintID={currentPrintID}
                            printID={printID}
                            landscapeBoolean={landscapeBoolean}
                            activeWeek={activeWeek}
                            printUpdateRequest={printUpdateRequest}
                            printFlyerRequest={printNewspaperRequest}
                        />
                    </div>
                ) : (
                    <div>Dieses Feature ist nicht freigeschaltet. Bei Interesse kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                )}
            </div>
        </WrapperPageSpinner>
    )
}

export default PrintNewspaper

